import React from "react";
import TextInfo, {
  TEXT_INFO_DISPLAY,
  TEXT_INFO_KIND,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_COLOR,
} from "@gcloud-npm/next12.components.text-info";
// import Sticky, { STICKYTYPES } from "@gcloud-npm/next12.components.sticky";
import Sticky, { STICKYTYPES } from "@gcloud-npm/next12.components.sticky-bar";
import Button, {
  BUTTON_TYPE,
  BUTTON_FONT_FAMILY,
} from "@gcloud-npm/next12.components.button-n";

const MAIN_TAGGING_INFO = {
  componentProduct: "alarmas",
  componentName: "barra-anclada",
  componentVariation: "all",
  componentContent: "calcular-ahora",
  componentePerso: "",
};

const BottomBar = ({url}) => {
  return (
    <Sticky type={STICKYTYPES.DYNAMICBOTTOM}>
      <div className="bottom-bar">
        <div className="image">
          <img
            className="photo"
            src={`${process.env.NEXT_PUBLIC_CDN}/estaticos/imagenes/fichas-producto/logo-soteira-movistar.png`}
            alt="alarmas para chalets"
          />
        </div>
        <div className="text">
          <TextInfo
            text="Calcula tu precio en 1 minuto"
            display={TEXT_INFO_DISPLAY.BLOCK}
            kind={TEXT_INFO_KIND.HEADING}
            level={3}
            size={TEXT_INFO_SIZE.CAPTION2}
            fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
            color={TEXT_INFO_COLOR.BLACK}
          />
        </div>
        <div className="button">
          <Button
            buttonType={BUTTON_TYPE.PRIMARY}
            fontFamily={BUTTON_FONT_FAMILY.LIGHT}
            label="Calcular Ahora"
            taggingInfo={{
              ...MAIN_TAGGING_INFO,
              componentName: "barra-anclada",
              componentContent: "calcular-ahora",
            }}
            href={`${url}#customizer`}
          />
        </div>
      </div>
      <style jsx>
        {`
          .bottom-bar {
            background-color: white;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 0.5rem 0;
            border-top: 0.2px solid var(--color-gp--grey3);
          }
          @media screen and (max-width: 768px) {
            .photo {
              display: none;
            }
          }
        `}
      </style>
    </Sticky>
  );
};

export default BottomBar;
